var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsFrame7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#FFAC30",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5234 23.2915L24.7318 28.0832L21.3776 24.729L22.8151 23.2915L24.7318 25.2082L28.0859 21.854L29.5234 23.2915ZM12.7526 8.9165C11.6889 8.9165 10.8359 9.76942 10.8359 10.8332V26.1665C10.8359 27.2303 11.6889 28.0832 12.7526 28.0832H20.2372C19.7293 27.2111 19.4609 26.2144 19.4609 25.2082C19.4609 24.8919 19.4897 24.5661 19.5376 24.2498H12.7526V22.3332H20.2372C20.678 21.5665 21.2914 20.8957 22.0293 20.4165H12.7526V18.4998H24.2526V19.5348C24.5689 19.4869 24.8947 19.4582 25.2109 19.4582C25.5368 19.4582 25.853 19.4869 26.1693 19.5348V14.6665L20.4193 8.9165M19.4609 10.354L24.7318 15.6248H19.4609V10.354Z",
    fill: "#FFAC30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsFrame7);
export default __webpack_public_path__ + "static/media/stats_frame_7.4638086aaeeb6e95b0a955a302cefc3f.svg";
export { ForwardRef as ReactComponent };